<div class="row">
    <a [href]="arr.link" class="col-lg-4 news-box" *ngFor="let arr of news">
        <div class="image">
            <img [src]="arr.image" [alt]="arr.title">
        </div>
        <h2 class="title">{{arr.title}}</h2>
        <span class="news-info">{{arr.content}}</span>
    </a>
</div>